var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualityCheckV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3307 10.9158C17.3307 15.4991 14.1224 17.7908 10.3091 19.1199C10.1094 19.1876 9.89247 19.1844 9.6949 19.1108C5.8724 17.7908 2.66406 15.4991 2.66406 10.9158V4.49911C2.66406 4.25599 2.76064 4.02284 2.93255 3.85093C3.10446 3.67902 3.33761 3.58244 3.58073 3.58244C5.41406 3.58244 7.70573 2.48244 9.30073 1.08911C9.49493 0.923192 9.74197 0.832031 9.9974 0.832031C10.2528 0.832031 10.4999 0.923192 10.6941 1.08911C12.2982 2.49161 14.5807 3.58244 16.4141 3.58244C16.6572 3.58244 16.8903 3.67902 17.0622 3.85093C17.2342 4.02284 17.3307 4.25599 17.3307 4.49911V10.9158Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89062 9.2398L7.9837 11.3329L12.1698 7.14673",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 10.863L11.4873 13.3747L10.5 12.5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityCheckV2);
export default __webpack_public_path__ + "static/media/qualityCheckV2.590f96df9668f5e55c81a44c597355ba.svg";
export { ForwardRef as ReactComponent };